module.exports = __webpack_public_path__ + "static/media/3.523fde3d.JPG";